import { render, staticRenderFns } from "./AddPlatform.vue?vue&type=template&id=1b2940ca"
import script from "./AddPlatform.vue?vue&type=script&lang=js"
export * from "./AddPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports